import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { useNavigate } from 'react-router-dom';

function Footer() {
    const navigate = useNavigate();

    return (
        <Box
            component="footer"
            sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
                px: 5,
                py: 3,
                textAlign: 'center',
                borderTop: '1px solid #e0e0e0',
                backgroundColor: '#f5f5f5',
                marginTop: 'auto',
                width: '100%'
            }}>
            <Box
                sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 3
                }}>
                <Button
                    sx={{
                        color: '#999999',
                        textTransform: 'none',
                        fontSize: '0.875rem',
                        '&:hover': { color: '#2574eb' }
                    }}
                    onClick={() => navigate('/aboutus')}>
                    About
                </Button>
            </Box>
            <Typography sx={{ color: '#999999', fontSize: '0.75rem' }}>
                © 2025 capsuleme. All rights reserved.
            </Typography>
        </Box>
    );
}

export default Footer;